import { render, staticRenderFns } from "./ReferralLinks.vue?vue&type=template&id=0f6023a0&scoped=true&"
import script from "./ReferralLinks.vue?vue&type=script&lang=ts&"
export * from "./ReferralLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6023a0",
  null
  
)

export default component.exports